export enum SalesPage {
  SEARCH,
  BOOKMARKS,
  MY_AUCTIONS,
  FINISHED_OFFERS
}
